import { useEffect } from "react";
import { MainHeader } from "./main-header/main-header.component";
import { MainSubHeader } from "./main-sub-header/main-sub-header.component";
import { Outlet, useLocation } from "react-router-dom";
import { DevelopmentBanner } from "../../../shared-module/components/development-banner/development-banner.component";
import { UnderMaintenanceBanner } from "../under-maintenance/under-maintenance.component";
import { AutoExpireComponent } from "../auto-expire-notification/auto-expire-notification.component";
import { InternalErrorBanner } from "../internal-server-error/internal-server-error-component";
import { ChatWidget } from "../chat-widget/chat-widget.component";


function LayoutComponent() {
  const location = useLocation();

  useEffect(() => {
    scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  }, [location]);

  const isHomePage = location.pathname === "/" || location.pathname === "/home";

  return (
    <div className="bds-page-wrapper">
      <InternalErrorBanner></InternalErrorBanner>
      <DevelopmentBanner></DevelopmentBanner>
      <UnderMaintenanceBanner></UnderMaintenanceBanner>
      <AutoExpireComponent></AutoExpireComponent>

      {/* Only show old header/sub-header on non-home pages */}
      {!isHomePage && (
        <header>
          <MainHeader></MainHeader>
          <MainSubHeader></MainSubHeader>
        </header>
      )}

      <main className={isHomePage ? "bds-main-content bds-main-content--full" : "bds-main-content"}>
        {isHomePage ? (
          <Outlet></Outlet>
        ) : (
          <div className="container bds-container py-4">
            <Outlet></Outlet>
          </div>
        )}
      </main>

      <footer className="page-footer">
        <div className="footer-contents container bds-container py-4">
          <div className="bds-footer-inner">
            <p className="bds-footer-text">
              For assistance and questions, contact your local district office:&ensp;
              <a href="http://www.in.gov/fssa/ddrs/4088.htm" className="bds-footer-link" target="_blank" rel="noreferrer">
                in.gov/fssa/ddrs/4088.htm
              </a>
            </p>
            <p className="bds-footer-legal">
              &copy; {new Date().getFullYear()} Indiana Family &amp; Social Services Administration. All rights reserved.
            </p>
          </div>
        </div>
      </footer>

      <ChatWidget />
    </div>
  );
}

export const Layout = LayoutComponent;
